{
  "de": {
    "ai": {
      "assistant": {
        "all_projects": "Alle Projekte",
        "cap": {
          "action": "Neue Konversation starten",
          "message": "Sie haben das Konversationslimit erreicht."
        },
        "empty_state": {
          "subtitle": "Fragen Sie mich alles über Ihre Kunden",
          "title": "Wie kann ich Ihnen helfen?"
        },
        "errors": {
          "budget_reached": "Das KI-Budget dieses Monats ist aufgebraucht. Wenden Sie sich an Ziggu, um es zu erhöhen.",
          "generic": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut."
        },
        "history": {
          "empty": "Noch keine früheren Konversationen",
          "title": "Frühere Konversationen"
        },
        "input": {
          "disclaimer": "Ergebnisse können ungenau sein. Überprüfen Sie wichtige Informationen immer.",
          "hint": "Enter zum Senden · Shift+Enter für neue Zeile",
          "placeholder": "Fragen Sie zu Ihren Kunden..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Wie richte ich Benachrichtigungen ein?",
          "help_project_settings": "Wo finde ich die Projekteinstellungen?",
          "open_decisions": "Welche Entscheidungen sind noch offen?",
          "unassigned_units": "Welche Einheiten haben noch keinen Kunden?"
        },
        "support_cta": {
          "action": "Support kontaktieren",
          "prompt": "Nicht die Antwort, die Sie gesucht haben?"
        }
      },
      "dashboard": {
        "agents": {
          "all": "Alle Module",
          "assistant": "Assistent",
          "conversation_agent": "Konversationsagent",
          "label": "Modul"
        },
        "clients": {
          "allowance_split": "Kostenlos {free} · Bezahlt {paid}",
          "columns": {
            "allowance": "Budget",
            "chats": "Chats im Zeitraum",
            "client": "Kunde",
            "spend": "Ausgaben im Zeitraum",
            "status": "Status",
            "used": "Diesen Monat verbraucht"
          },
          "empty": "Kein Kunde hat in diesem Zeitraum KI genutzt",
          "export": "Exportieren",
          "title": "Kunden"
        },
        "empty_hint": "Keine Treffer für dieses Modul und diesen Zeitraum.",
        "intent_mix": {
          "empty": "Keine Chats in diesem Zeitraum",
          "row": "{chats} Chat · {amount} | {chats} Chats · {amount}",
          "title": "Verteilung nach Absicht"
        },
        "intents": {
          "draft": "Antwort entwerfen",
          "none": "Ohne Absicht",
          "question": "Fragen",
          "summary": "Zusammenfassung"
        },
        "kpi": {
          "clients_active": "Aktive Kunden",
          "employees_active": "Aktive Mitarbeiter",
          "spend_month": "Ausgaben diesen Monat",
          "spend_month_detail": "Laufender Kalendermonat",
          "spend_range": "Ausgaben im Zeitraum",
          "spend_range_detail": "{count} Konversation in diesem Zeitraum | {count} Konversationen in diesem Zeitraum",
          "spend_today": "Ausgaben heute",
          "tickets_assisted": "Unterstützte Tickets"
        },
        "load_failed": {
          "description": "Laden Sie die Seite neu oder wählen Sie einen anderen Zeitraum.",
          "title": "KI-Nutzung konnte nicht geladen werden"
        },
        "range": {
          "label": "Zeitraum"
        },
        "spend": {
          "empty": "Keine Ausgaben in diesem Zeitraum",
          "monthly_empty": "Keine Ausgaben in den letzten {months} Monaten",
          "monthly_hint": "Letzte {months} Monate · unabhängig vom gewählten Zeitraum",
          "monthly_title": "Kosten pro Monat",
          "monthly_total": "{amount} in den letzten {months} Monaten · unabhängig vom gewählten Zeitraum",
          "title": "Ausgaben pro Tag",
          "total": "{amount} im Zeitraum",
          "view": {
            "label": "Ausgaben anzeigen",
            "per_day": "Pro Tag",
            "running_total": "Kumuliert"
          }
        },
        "status": {
          "over": "Budget überschritten",
          "over_days": "Überschritten · 1 Tag | Überschritten · {count} Tage"
        },
        "title": "KI-Nutzung"
      },
      "settings": {
        "budget": {
          "description": "Monatliche Kostenobergrenze für die KI-Nutzung (Testphase). Wird basierend auf der Token-Nutzung in allen Konversationen dieses Monats neu berechnet.",
          "free_label": "Kostenloses Budget",
          "override_help": "Leer lassen, um den Paketbetrag zu verwenden ({amount}).",
          "override_label": "Individuelles kostenloses Budget",
          "paid_label": "Bezahltes Budget",
          "save": "Speichern",
          "title": "Monatliches Budget",
          "total_label": "Gesamtbudget",
          "usage_label": "Diesen Monat verbraucht",
          "use_package_amount": "Paketbetrag verwenden"
        },
        "description": "Konfiguration der KI-Funktionen in Ihrer Organisation.",
        "title": "KI-Einstellungen",
        "usage": {
          "description": "Wie viel des KI-Kontingents in diesem Monat verbraucht ist. Bei 100 % stoppen die KI-Funktionen, bis das Kontingent im nächsten Monat zurückgesetzt wird.",
          "title": "KI-Nutzung"
        }
      },
      "ticket_assistant": {
        "actions": {
          "adjust": "Anpassen",
          "ask": "Fragen",
          "draft": "Antwort entwerfen",
          "draft_empty": "Noch keine Nachrichten zum Beantworten",
          "follow_up": "Rückfrage",
          "follow_up_stop": "Rückfrage beenden",
          "new": "Neue Frage",
          "summary": "Konversation zusammenfassen",
          "summary_empty": "Noch keine Nachrichten zum Zusammenfassen",
          "use_as_reply": "Als Antwort verwenden"
        },
        "adjusting_draft": "Anpassung dieses Entwurfs",
        "beta": "Beta",
        "budget": {
          "description": "Das KI-Budget dieses Monats ist aufgebraucht. Frühere Antworten bleiben verfügbar.",
          "request": "Wir haben das KI-Budget dieses Monats aufgebraucht und möchten es erhöhen.",
          "request_low": "Wir haben das KI-Budget dieses Monats fast aufgebraucht und möchten es erhöhen.",
          "title": "KI-Budget erreicht",
          "warn": "{percent} % des KI-Budgets dieses Monats verbraucht."
        },
        "cap": "Dieser Chat ist lang geworden. Stellen Sie besser eine neue Frage.",
        "collapse": "Assistent ausblenden",
        "conversation": "Konversation",
        "digest": {
          "decisions_open": "keine offenen Entscheidungen | 1 offene Entscheidung | {count} offene Entscheidungen",
          "installments_unpaid": "keine unbezahlten Raten | 1 unbezahlte Rate | {count} unbezahlte Raten",
          "issues_open": "keine offenen Nachbetreuungsmeldungen | 1 offene Nachbetreuungsmeldung | {count} offene Nachbetreuungsmeldungen",
          "nothing_open": "Nichts offen für diese Einheit",
          "overdue": "{count} überfällig",
          "title": "Auf einen Blick"
        },
        "earlier_answers": "Frühere Antworten",
        "empty": "Fragen Sie etwas zu dieser Konversation, oder beginnen Sie mit einer davon.",
        "expand": "Assistent einblenden",
        "following_up": "Rückfrage zu dieser Antwort",
        "footer": "Nur für Sie sichtbar. Antworten werden von KI erstellt und können Fehler enthalten.",
        "input": {
          "adjust_draft": "Entwurf anpassen, z. B. kürzer oder förmlicher",
          "follow_up": "Rückfrage stellen",
          "label": "Ihre Frage",
          "placeholder": "Fragen zu dieser Konversation"
        },
        "links": {
          "aftercare": "Nachbetreuung",
          "decisions": "Entscheidungen",
          "financials": "Finanzen"
        },
        "placeholders": {
          "confirm": {
            "accept": "Trotzdem senden",
            "header": "Mit Platzhaltern senden?",
            "message": "Der Assistent hat in dieser Antwort 1 Platzhalter hinterlassen, den Sie noch nicht ausgefüllt haben. | Der Assistent hat in dieser Antwort {count} Platzhalter hinterlassen, die Sie noch nicht ausgefüllt haben."
          },
          "remaining": "noch 1 Platzhalter ausfüllen | noch {count} Platzhalter ausfüllen"
        },
        "replace_reply": {
          "confirm": {
            "accept": "Ersetzen",
            "header": "Ihren Text ersetzen?",
            "message": "Der Entwurf ersetzt den Text im Antwortfeld."
          }
        },
        "suggestions": {
          "history": "Wie ist die Historie mit diesem Kunden?",
          "issues_open": "Wie viele Nachbetreuungspunkte sind noch offen?",
          "undecided": "Was hat dieser Kunde noch nicht entschieden?"
        },
        "thinking": "Der Assistent arbeitet...",
        "title": "Assistent"
      }
    }
  }
}
